<template>
  <WBDAutoCompleteSelectorFilter
    :filtered-laborer-list="''"
    :remote-list="remoteList"
    :label="label"
    :on-change-event="onChangeEvent"
    :remote-option-value="selectedOptionValue"
    :model-list="modelList"
    hideSearchIcon
    :clear-event="clearEvent"
    @onShiftProviderLevelChange="onShiftProviderLevelChange"
  />
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import WBDAutoCompleteSelectorFilter from '@/components/common/filter/auto-complete-filter'
import { SHIFT_PROVIDER_LEVEL_STARTER } from '@/views/office/view'

export default {
  name: 'WBDShiftProviderLevelList',
  components: { WBDAutoCompleteSelectorFilter },
  props: {
    label: {
      type: String,
      default: 'Новый объект'
    },
    remoteOptionValue: {
      type: String,
    },
    remoteList: {
      type: Array,
    },
  },
  data () {
    return {
      loading: false,
      clearEvent: false,
      searchQuery: null,
      onChangeEvent: 'onShiftProviderLevelChange',
      modelList: [

        {
          'id': 'no', 'title': 'Нет',
        },
        {
          'id': SHIFT_PROVIDER_LEVEL_STARTER,
          'title': 'Да',
        }
      ],
      selectedOptionValue: null,

    }
  },
  computed: {
    ...mapGetters({
    }),
    getModelList () {
      return this.modelList
    },
  },
  created () {
    if (this.remoteOptionValue) {
      this.selectedOptionValue = this.remoteOptionValue
    }
    this.clearEvent = this.eventNames.SHIFT_PROVIDER_LEVEL_FILTER_RESET
    this.eventsBus.$on(this.clearEvent, () => {
      this.selectedOptionValue = null
      this.searchQuery = null
    })
  },
  methods: {
    ...mapMutations({
    }),
    ...mapActions({
    }),
    onShiftProviderLevelChange (data) {
      this.$emit(
        this.onChangeEvent,
        data
      )
    },
  }
}
</script>
